import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormUtilsService {
  unwrapSingleSelect<T>(
    value: T | T[] | null | undefined
  ): T | undefined {
    if (Array.isArray(value)) {
      return value.length > 0 ? value[0] : undefined;
    }
    return value ?? undefined;
  }
}
